import React from 'react';
import { observer } from 'mobx-react';
import { observable } from 'mobx';
import styled from '@emotion/styled';
import autobind from 'autobind-decorator';
import { AppUI } from '@seedlang/state';
import { Theme } from '@seedlang/constants';
import Modal from 'components/modal';
import Button from 'components/button/button';
import Spinner from 'components/spinner';
import { Link } from 'react-router';

const DeleteModal = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  p {
    margin: 20px 0 0 0;
  }
  padding: 10px;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  margin-top: 20px;
  gap: 10px;

  & > * {
    width: 100%;
  }
`;

const LinkButton = styled.button`
  background: none;
  border: none;
  color: ${Theme.darkestBlue};
  text-decoration: underline;
  cursor: pointer;
  font-size: 16px;
`;

@observer
class DeleteAccountModal extends React.Component {
  @observable showDeletionConfirmation = false;
  @observable deletionSuccess = false;
  @observable showDeletionSpinner = false;

  @autobind onDeleteUser() {
    this.showDeletionSpinner = true;
    AppUI.userStore.destroy({ ids: { userId: AppUI.user.id } }, this.afterDeleteUser);
  }

  @autobind afterDeleteUser(resp) {
    this.showDeletionConfirmation = true;
    this.showDeletionSpinner = false;
    this.deletionSuccess = resp['success'];
    if (this.deletionSuccess) {
      AppUI.signOut();
    }
  }

  render() {
    const {
      onClose,
      activeStripeSubscriptionExists,
      title = 'Delete Account',
    } = this.props;

    return (
      <Modal
        onCloseModal={onClose}
        width='100%'
        maxWidth='500px'
      >
        <DeleteModal>
          <h3>{title}</h3>
          {
            !this.showDeletionConfirmation && !this.showDeletionSpinner &&
            <>
              {
                activeStripeSubscriptionExists
                  ? 'Deleting your account is irreversible. To keep your progress and free features, you can cancel your membership instead and return anytime.'
                  : 'Are you sure that you want to delete your account and all of your data? This is not a reversible action.'
              }
              <ButtonGroup>
                {
                  activeStripeSubscriptionExists &&
                  <Link
                    to={{name: 'settings.billing'}}
                  >
                    <Button
                      background={Theme.green}
                      width='100%'
                    >
                      Manage Membership
                    </Button>
                  </Link>
                }
                <Button
                  onClick={this.onDeleteUser}
                  background={Theme.red}
                  width='100%'
                >
                  Delete Account
                </Button>
                <LinkButton
                  onClick={onClose}
                >
                  Cancel
                </LinkButton>
              </ButtonGroup>
            </>
          }
          {
            this.showDeletionSpinner &&
            <div style={{ textAlign: 'center' }}>
              <div>Your account is being deleted.</div>
              <div>You will be signed out.</div>
              <Spinner background={AppUI.site.accentColor} />
            </div>
          }
          {
            this.showDeletionConfirmation && !this.deletionSuccess &&
            <div style={{ textAlign: 'center' }}>
              <div>Your account will be deleted by our team within 72 hours.</div>
              <br />
              <div>You can contact our support team if you have any questions.</div>
              <Link to='contact'>
                <Button
                  background={AppUI.siteIsDefault ? Theme.blue : AppUI.site.accentColor}
                  margin='10px 0 0 0'
                >
                  Contact Us
                </Button>
              </Link>
            </div>
          }
        </DeleteModal>
      </Modal>
    );
  }
}

export default DeleteAccountModal;